// /src/pages/admin/Clientes.tsx
import React, { useState } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { IEmpresaCliente } from '../../types';
import { mockClientes } from '../../mocks/clientes';

export const Clientes: React.FC = () => {
  const [clientes, setClientes] = useState<IEmpresaCliente[]>(mockClientes);
  const [nuevoCliente, setNuevoCliente] = useState<Partial<IEmpresaCliente>>({
    nombre: '',
    nit: '',
    contacto: '',
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const handleCrearCliente = () => {
    if (!nuevoCliente.nombre || !nuevoCliente.nit || !nuevoCliente.contacto) {
      toast({
        title: 'Error',
        description: 'Completa todos los campos',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    const cliente: IEmpresaCliente = {
      id: `empresa-${Date.now()}`,
      nombre: nuevoCliente.nombre,
      nit: nuevoCliente.nit,
      contacto: nuevoCliente.contacto,
    };

    setClientes([...clientes, cliente]);
    
    toast({
      title: 'Cliente creado',
      description: `${cliente.nombre} ha sido agregado exitosamente`,
      status: 'success',
      duration: 3000,
    });

    setNuevoCliente({ nombre: '', nit: '', contacto: '' });
    onClose();
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={6}>
        <Heading size="lg">Gestión de Clientes</Heading>
        <Button colorScheme="blue" onClick={onOpen}>
          + Crear Cliente
        </Button>
      </Box>

      <Box bg="white" borderRadius="lg" boxShadow="sm" overflow="hidden">
        <Table variant="simple">
          <Thead bg="gray.50">
            <Tr>
              <Th>Razón Social</Th>
              <Th>NIT</Th>
              <Th>Contacto</Th>
            </Tr>
          </Thead>
          <Tbody>
            {clientes.map((cliente) => (
              <Tr key={cliente.id}>
                <Td fontWeight="medium">{cliente.nombre}</Td>
                <Td>{cliente.nit}</Td>
                <Td>{cliente.contacto}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {/* Modal para crear cliente */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Crear Nuevo Cliente</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>Razón Social</FormLabel>
              <Input
                value={nuevoCliente.nombre}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, nombre: e.target.value })}
                placeholder="Nombre de la empresa"
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>NIT</FormLabel>
              <Input
                value={nuevoCliente.nit}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, nit: e.target.value })}
                placeholder="123456789-0"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Contacto</FormLabel>
              <Input
                value={nuevoCliente.contacto}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, contacto: e.target.value })}
                placeholder="Nombre - email@empresa.com"
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="blue" onClick={handleCrearCliente}>
              Crear Cliente
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};
